"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lib = require("../../lib");

var _common = require("../../common");

var _Content = _interopRequireDefault(require("./Content"));

require("./styles.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Popup =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Popup, _PureComponent);

  function Popup(props) {
    var _this;

    _classCallCheck(this, Popup);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Popup).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "classNames", function () {
      var names = [Popup.className];
      (0, _lib.addClassByPropName)(names, _this.props, ['disabled']);
      var _this$props = _this.props,
          trigger = _this$props.trigger,
          disabled = _this$props.disabled;

      if (trigger === 'hover' && !disabled) {
        (0, _lib.addClassName)(names, 'hoverable');
      }

      return names.join(' ');
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnToggle", function (e) {
      var visible = _this.state.visible;
      var _this$props2 = _this.props,
          disabled = _this$props2.disabled,
          trigger = _this$props2.trigger,
          onClick = _this$props2.onClick;
      (0, _lib.callEventMethods)(e, 'persist', 'preventDefault', 'stopPropagation');

      if (disabled) {
        return;
      }

      if (trigger === 'click') {
        if (!visible) {
          _this.handleOnOpen(e);
        } else {
          _this.handleOnClose(e);
        }
      }

      if (onClick) {
        onClick(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnOpen", function (e) {
      (0, _lib.callEventMethods)(e, 'persist', 'stopPropagation');
      var disabled = _this.props.disabled;

      if (disabled) {
        return;
      }

      var visible = _this.state.visible;

      if (!visible) {
        _this.setState({
          visible: true
        }, function () {
          _this.handleOnShow(e);
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnClose", function (e) {
      (0, _lib.callEventMethods)(e, 'persist', 'stopPropagation');
      var disabled = _this.props.disabled;

      if (disabled) {
        return;
      }

      var visible = _this.state.visible;

      if (visible) {
        _this.setState({
          visible: false
        }, function () {
          _this.handleOnHide(e);
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleCheckClose", function (e) {
      (0, _lib.callEventMethods)(e, 'persist', 'stopPropagation');
      var visible = _this.state.visible;

      if (visible) {
        var current = _this.innerRef.current;

        if (current && !current.contains(e.target)) {
          _this.handleOnClose(e);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnShow", function (e) {
      var _this$props3 = _this.props,
          onOpen = _this$props3.onOpen,
          trigger = _this$props3.trigger;

      if (trigger === 'click') {
        document.addEventListener('click', _this.handleCheckClose);
      }

      if (onOpen) {
        onOpen(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnHide", function (e) {
      var _this$props4 = _this.props,
          onClose = _this$props4.onClose,
          trigger = _this$props4.trigger;

      if (trigger === 'click') {
        document.removeEventListener('click', _this.handleCheckClose);
      }

      if (onClose) {
        onClose(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderContent", function () {
      var _this$props5 = _this.props,
          basic = _this$props5.basic,
          asContent = _this$props5.asContent,
          content = _this$props5.content,
          direction = _this$props5.direction,
          offset = _this$props5.offset,
          disabled = _this$props5.disabled,
          trigger = _this$props5.trigger,
          contentClassName = _this$props5.contentClassName,
          oneSide = _this$props5.oneSide;
      var visible = _this.state.visible;
      var isClick = trigger === 'click';
      return _react["default"].createElement(_Content["default"], {
        as: asContent,
        className: contentClassName,
        visible: visible,
        direction: direction,
        offset: offset,
        onClick: !basic && isClick ? _this.handleOnClose : null,
        disabled: disabled,
        oneSide: oneSide
      }, (0, _lib.getRenderProps)(content, {
        disabled: disabled,
        visible: visible,
        close: _this.handleOnClose
      }));
    });

    var _visible = props.visible;
    _this.state = {
      prevProps: {
        visible: _visible
      },
      // this only store props.visible
      visible: _visible
    };
    _this.innerRef = _react["default"].createRef();
    return _this;
  }

  _createClass(Popup, [{
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          as = _this$props6.as,
          basic = _this$props6.basic,
          asContent = _this$props6.asContent,
          className = _this$props6.className,
          children = _this$props6.children,
          contentClassName = _this$props6.contentClassName,
          content = _this$props6.content,
          visible = _this$props6.visible,
          offset = _this$props6.offset,
          direction = _this$props6.direction,
          trigger = _this$props6.trigger,
          onOpen = _this$props6.onOpen,
          onClose = _this$props6.onClose,
          onClick = _this$props6.onClick,
          oneSide = _this$props6.oneSide,
          innerRef = _this$props6.innerRef,
          rest = _objectWithoutProperties(_this$props6, ["as", "basic", "asContent", "className", "children", "contentClassName", "content", "visible", "offset", "direction", "trigger", "onOpen", "onClose", "onClick", "oneSide", "innerRef"]);

      var Wrapper = (0, _lib.getElementType)(this, this.props);
      var classNames = this.classNames();
      var isHover = trigger === 'hover';
      var ref = innerRef || this.innerRef;
      return _react["default"].createElement(Wrapper, _extends({}, rest, {
        ref: ref,
        className: classNames,
        onFocus: !basic && isHover ? this.handleOnOpen : null,
        onBlur: !basic && isHover ? this.handleOnClose : null,
        onMouseOver: !basic && isHover ? this.handleOnOpen : null,
        onMouseOut: !basic && isHover ? this.handleOnClose : null,
        onClick: !basic ? this.handleOnToggle : null
      }), (0, _lib.getRenderProps)(children, {
        disabled: rest.disabled,
        visible: this.state.visible,
        toggle: this.handleOnToggle,
        open: this.handleOnOpen,
        close: this.handleOnClose
      }), this.renderContent());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps; // Compare the incoming prop to previous prop

      var visible = props.visible;
      return {
        // Store the previous props in state
        prevProps: {
          visible: visible
        },
        visible: prevProps.visible !== visible ? visible : state.visible
      };
    }
  }]);

  return Popup;
}(_react.PureComponent);

exports["default"] = Popup;

_defineProperty(Popup, "Content", _Content["default"]);

_defineProperty(Popup, "className", 'MHub-Popup');

_defineProperty(Popup, "displayName", 'Popup');

_defineProperty(Popup, "propTypes", {
  as: _common.customPropTypes.as,
  basic: _propTypes["default"].bool,
  asContent: _common.customPropTypes.as,
  visible: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  contentClassName: _propTypes["default"].string,
  children: _common.customPropTypes.render.isRequired,
  content: _common.customPropTypes.render.isRequired,
  onClick: _propTypes["default"].func,
  onOpen: _propTypes["default"].func,
  onClose: _propTypes["default"].func,
  disabled: _propTypes["default"].bool,
  trigger: _propTypes["default"].oneOf(['click', 'hover']),
  direction: _propTypes["default"].oneOfType([_common.customPropTypes.directionAll, _propTypes["default"].arrayOf(_common.customPropTypes.directionAll)]),
  offset: _propTypes["default"].oneOfType([_common.customPropTypes.stringOrNumber, _propTypes["default"].shape({
    top: _common.customPropTypes.stringOrNumber,
    bottom: _common.customPropTypes.stringOrNumber,
    left: _common.customPropTypes.stringOrNumber,
    right: _common.customPropTypes.stringOrNumber
  })]),
  oneSide: _propTypes["default"].bool,
  innerRef: _common.customPropTypes.ref
});

_defineProperty(Popup, "defaultProps", {
  as: null,
  basic: false,
  asContent: null,
  className: null,
  contentClassName: null,
  visible: false,
  onClick: null,
  onOpen: null,
  onClose: null,
  disabled: false,
  trigger: 'click',
  direction: 'bottom',
  offset: null,
  oneSide: false,
  innerRef: null
});